export const stringCleaner = (content = ''): string => {
  const stringsToReplace = ['&nbsp;', '<s*/?div.*?>', '<s*/?font.*?>', '<s*/?span.*?>'];

  return stringsToReplace.reduce((previous, current) => {
    const contentTrimmed = previous ? previous : content.trim();
    const regex = new RegExp(current, 'gi');

    return contentTrimmed.replace(regex, '');
  }, '');
};
